module.exports = __webpack_public_path__ + "img/why-front.01ab606b.jpg";